export const APP_VERIFY_PARAMS = 'app/APP_VERIFY_PARAMS';
export const APP_VERIFY_CODE_EXISTS = 'app/APP_VERIFY_CODE_EXISTS';

export const verifyParams = () => ({
  type: APP_VERIFY_PARAMS
});

export const verifyCodeExists = () => ({
  type: APP_VERIFY_CODE_EXISTS
});



// WEBPACK FOOTER //
// ./src/core/app/index.js